module.exports = __webpack_public_path__ + "assets/img/vue_starter_git_repository.d6a9b592.jpg";